import axios from "@axios";
import * as ep from "./endpoints";
export default class Service {
  static getIncentives() {
    return axios.get(ep.INCENTIVES).then((res) => res.data);
  }
  static getIncentive(id) {
    return axios.get(ep.INCENTIVE_BY_ID(id)).then((res) => res.data);
  }
}
